import * as React from 'react';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import { Radio, Icon, Row, Col, Tooltip } from 'antd';
import { sortByOptions, sortByWhenNoLocals, getGAEventCategory } from './DiscoverRateUtils';
import { bindActionCreators } from 'redux';
import { getAllDataSetSortByFilter } from 'src/actions/discoverRatesActions';
import { SortByFilters } from './TypesInDiscoverRates/SelectedFilters';

const styles = () => ({
  mainDiv: {
    marginTop: '22%',
    background: '#FFFFFF',
    position: 'absolute',
    zIndex: 10,
    width: '90%',
    padding: '15px 15px 10px 15px',
    display: 'flex',
    border: '1px solid #D9D9D9',
    flexDirection: 'column',
    boxShadow: '2px 2px 2px 0 rgba(0, 0, 0, 0.08)',
    fontSize: '12px',
    borderRadius: '2px',
  },
  radioStyle: {
    display: 'inline-block',
    lineHeight: '30px',
    fontSize: '12px',
  },
  radioDiv: {
    marginTop: '15px',
  },
  orderIcon: {
    cursor: 'pointer',
    fontSize: '12px',
  },
  centerAlign: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

interface DiscoverRateSortByPopupProps {
  classes: {
    [X in keyof ReturnType<typeof styles>]: string
  };
  handleCloseFilters: () => void;
  getAllDataSetSortByFilter: (e)  => void;
  sortByFilters: SortByFilters;
  isLoading: boolean;
  isLocalsPresent: boolean;
  activeKey: string;
  orgType: string;
  mode: string;
}

const { useEffect } = React;

const DiscoverRateSortByPopup = (props: DiscoverRateSortByPopupProps): React.ReactElement => {

  const {
    classes,
    handleCloseFilters,
    getAllDataSetSortByFilter,
    sortByFilters,
    isLoading,
    isLocalsPresent,
    orgType,
    mode = 'FCL'
  } = props;

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onChange = (e) : void => {
    getGAEventCategory(orgType, 'Sort By', `${e.target.value} - ${sortByFilters.sortByOrder}`);
    getAllDataSetSortByFilter({
      sortBy: e.target.value,
    });
    handleCloseFilters();
  };

  const node: any = React.useRef(null);

  const handleClickOutside = (e) : void => {
    const { activeKey } = props;
    const { className } = node.current;
    const element = document.getElementsByClassName(className)[activeKey === 'SELL' ? 1 : 0];
    if (!element || element.contains(e.target)) {
      return;
    }
    handleCloseFilters();
  };

  const handleSortByOrder = (val) : void => {
    getGAEventCategory(orgType, 'Sort By', `${sortByFilters.sortBy} - ${val}`);
    getAllDataSetSortByFilter({ sortByOrder: val });
    handleCloseFilters();
  };

  const renderOptions = () : React.ReactElement => {
    const optionsToShow = isLocalsPresent ? sortByOptions : sortByWhenNoLocals[mode];
    return (
      <Radio.Group
        className={classes.radioDiv}
        onChange={onChange}
        value={sortByFilters.sortBy}
        disabled={isLoading}
        >
        {Object.keys(optionsToShow).map((key) => {
          return (
            <Row className={classes.centerAlign} >
              <Col span={18}>
                <Radio className={classes.radioStyle}
                  style={{ color: sortByFilters.sortBy === key ?
                    '#006EC3' : '#333333' }}
                  value={key}>
                  {optionsToShow[key]}
                </Radio>
              </Col>
              <Col>
                <Tooltip title="Descending Order" mouseEnterDelay={0.4}>
                  <Icon type="arrow-down"
                    className={classes.orderIcon}
                    onClick = {() => sortByFilters.sortByOrder !== 'DESC' &&
                      handleSortByOrder('DESC')}
                    style={{ marginRight: '7px',
                      color: sortByFilters.sortByOrder === 'DESC' &&
                      sortByFilters.sortBy === key ? '#006EC3' : '#666666' }} />
                  </Tooltip>
                 <Tooltip title="Ascending Order" mouseEnterDelay={0.4}>
                  <Icon type="arrow-up"
                    className={classes.orderIcon}
                    onClick = {() => sortByFilters.sortByOrder !== 'ASC' &&
                      handleSortByOrder('ASC')}
                    style={{ color: sortByFilters.sortByOrder === 'ASC' &&
                    sortByFilters.sortBy === key ? '#006EC3' : '#666666' }} />
                 </Tooltip>
              </Col>
            </Row>
          );
        })}
      </Radio.Group>
    );
  };

  return (
    <div className={classes.mainDiv} ref={node}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Sorted By</span>
        <Icon type="up" onClick={handleCloseFilters} />
      </div>
      {renderOptions()}
    </div>
  );
};

const mapStateToProps = ({ discoverRatesReducer, masterData }, ownProps) => ({
  sortByFilters: discoverRatesReducer.sortByFilters,
  orgType: masterData.userData.type,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllDataSetSortByFilter },
    dispatch,
  );

const DiscoverRateSortByPopupStyled = withStyles(styles)(DiscoverRateSortByPopup);
export default connect(mapStateToProps, mapDispatchToProps)(DiscoverRateSortByPopupStyled);
